import { useEffect, useRef, useState } from 'react';

// Back dismisses the current dialog while retaining the quote route. Removing
// the history entry on an ordinary close avoids accumulating duplicate pages.
export default function useQuoteModal(initialVisible = false) {
  const [visible, setVisible] = useState(initialVisible);
  const id = useRef(`quote-dialog-${Math.random()}`);
  useEffect(() => {
    if (!visible) return undefined;
    const dialogId = id.current;
    window.history.pushState({ ...window.history.state, quoteDialog: dialogId }, '', window.location.href);
    const onBack = () => setVisible(false);
    window.addEventListener('popstate', onBack);
    return () => {
      window.removeEventListener('popstate', onBack);
      if (window.history.state && window.history.state.quoteDialog === dialogId) {
        window.history.back();
      }
    };
  }, [visible]);
  return [visible, setVisible];
}
